import MapCache from "./component-library345.mjs";
import setCacheAdd from "./component-library346.mjs";
import setCacheHas from "./component-library347.mjs";
function SetCache(values) {
  var index = -1, length = values == null ? 0 : values.length;
  this.__data__ = new MapCache();
  while (++index < length) {
    this.add(values[index]);
  }
}
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
export {
  SetCache as default
};
